lmApp.
  directive('lmSelectMultipleGroup', ['$window', '$document', '$timeout', '$rootScope',
    function ($window, $document, $timeout, $rootScope) {
      return {
        restrict: 'E',
        replace: true,
        scope: {
          ngModel: '=',
          options: '=',
          placeholder: '@',
          limit: '@',
          withSearch: '@',
          error: '@',
          errorFn: '&',
          warning: '@',
          warningFn: '&',
          success: '@',
          successFn: '&',
          ngDisabled: '=?',
          optionSection: '@',
          optionType: '@',
          isSwitcher: '@',
          onFocus: '&',
          onBlur: '&'
        },
        link: function (scope, element, attrs) {
          scope._group_element_ = element;
          scope._input_ = element.find('.tag-container');
          scope._arrow_ = element.find('.mdi-chevron-down');
          scope._options_ = element.find('.select-dropdown');
          scope._search_ = element.find('#search');
          scope._body_ = angular.element('body');
          scope._empty_ = angular.element('<div id="empty" style="opacity: 0.7; height: 100%; left: 0; top: 0;"></div>');
          scope._empty_.css({'z-index': +scope._options_.css('z-index') - 1});

          if (typeof scope.errorFn !== 'function') {
            scope.errorFn = function () {
              return scope.errorFn;
            }
          }
          if (typeof scope.warningFn !== 'function') {
            scope.warningFn = function () {
              return scope.warningFn;
            }
          }
          if (typeof scope.successFn !== 'function') {
            scope.successFn = function () {
              return scope.successFn;
            }
          }

          if (!angular.isObject(scope.ngModel)) scope.ngModel = {};

          scope.localOptions = angular.copy(scope.options);
          scope.optWatcher = scope.$watchCollection('options', function (newValue, oldValue) {
            if (newValue) {
              scope.localOptions = {};

              _.forEach(angular.copy(newValue), function (n, key) {
                scope.localOptions[key] = n.map(function (item) {
                  item.selected = !!_.find(scope.ngModel[key], {id: item.id});
                  return item;
                });
              });
            }
          });

          var _OpenMultipleSelect = function () {
            if (scope.ngDisabled) return;

            if (scope.onFocus) scope.onFocus();

            scope._empty_.appendTo('body');
            scope._options_.appendTo('body');
            scope._options_.css({overflow: 'hidden'});
            scope._options_.css({display: 'block'});
            scope._ChangePosition();

            scope._options_.css({width: scope._group_element_.width()});

            TweenMax.from(scope._options_, 0.35, {
              height: 0,
              ease: Expo.easeInOut,
              onComplete: function () {
                scope._options_.css({'overflow-y': 'auto'});
                if (scope.withSearch) scope._search_.focus();
                scope._ChangeSize();

                scope._empty_.bind('click', _CloseMultipleSelect);
              },
              clearProps: 'height'
            });

            scope._input_.trigger('focus');
            angular.element('body').bind('keydown', _OnKeyDown);
            angular.element($window).bind('resize', scope._ChangePosition);
            angular.element($window).bind('resize', scope._ChangeSize);
            angular.element($window).bind('scroll', scope._ChangePosition);
          };

          var _CloseMultipleSelect = function (event) {
            scope._options_.css({overflow: 'hidden'});

            TweenMax.to(scope._options_, 0.35, {
              height: 0,
              display: 'none',
              ease: Expo.easeInOut,
              onComplete: function () {
                scope._options_.css({'overflow-y': 'auto'});
                scope._empty_.remove();
              },
              clearProps: 'height,width'
            });

            scope._empty_.unbind('click', _CloseMultipleSelect);
            angular.element('body').unbind('keydown', _OnKeyDown);
            angular.element($window).unbind('resize', scope._ChangePosition);
            angular.element($window).unbind('resize', scope._ChangeSize);
            angular.element($window).unbind('scroll', scope._ChangePosition);
            if (scope.onBlur) scope.onBlur();
          };

          scope._ChangePosition = function () {
            scope._options_.css({
              overflow: 'hidden',
              top: scope._input_.offset().top - $document.scrollTop(),
              left: scope._input_.offset().left - $document.scrollLeft()
            });
          };

          scope._ChangeSize = function () {
            scope._options_.css({width: scope._group_element_.width()});

            var bodyHeight = $document[0].documentElement.clientHeight;
            var optionsHeight = scope._options_.height();
            var optionsOffsetTop = scope._input_.offset().top - $document.scrollTop();
            var bodyScrollTop = angular.element('body').scrollTop();

            if (optionsHeight + optionsOffsetTop > bodyHeight) {
              scope._options_.css({height: bodyHeight - optionsOffsetTop + bodyScrollTop - 10});
            }
          };

          var _OnKeyDown = function (event) {

            // TAB - switch to another input
            if (event.which == 9) {
              if (event.preventDefault) event.preventDefault();
              if (event.stopPropagation) event.stopPropagation();
              _CloseMultipleSelect(event);
              return
            }

            // ESC - close options
            if (event.which == 27) {
              if (event.preventDefault) event.preventDefault();
              if (event.stopPropagation) event.stopPropagation();
              _CloseMultipleSelect();
            }
          };

          scope._input_.bind('click', _OpenMultipleSelect);
          scope._arrow_.bind('click', _OpenMultipleSelect);

          scope.selectOption = function (key, option) {
            var index = _.find(scope.ngModel[key], {id: option.id});

            if (scope.isSwitcher) {
              if (!index) {
                scope.localOptions[key].forEach(function (item) {
                  item.selected = false;
                });
                option.selected = true;

                scope.ngModel[key] = [option];
              } else {
                scope.removeFromSelection(key, option);
              }
            } else {
              if (!index) {
                option.selected = true;
                scope.ngModel[key].push(option);
              } else {
                scope.removeFromSelection(key, option);
              }
            }

            scope._ChangeSize();
          };

          scope.clearSearch = function () {
            scope.search = '';
            scope._search_.focus();
          };

          scope.removeTag = function (key, tag) {
            var option = _.find(scope.localOptions[key], {id: tag.id});

            if (option) {
              scope.removeFromSelection(key, option);
            } else {
              scope.removeFromSelection(key, tag);
            }
          };

          scope.removeFromSelection = function (key, option) {
            scope.ngModel[key].forEach(function (item, index) {
              if (option.id === item.id) {
                $timeout(function () {
                  option.selected = false;
                  scope.ngModel[key].splice(index, 1);
                })
              }
            });
          };

          scope.toCreate = function (path) {
            if (path) window.location.href = path;
          };

          scope.isEmpty = function (object) {
            return _.isEmpty(object) || _.reduce(object, function (result, n, key) {
                return result && !n.length;
              }, true);
          };

          scope.limitWatcher = scope.$watch('limit', function (newValue, oldValue) {
            if (newValue) {
              scope._ChangeSize();
            }
          });

          scope._group_element_.on('$destroy', function () {
            scope._input_.unbind('click', _OpenMultipleSelect);
            scope._arrow_.unbind('click', _OpenMultipleSelect);
            scope.optWatcher();
            scope.limitWatcher();
          });
        },
        templateUrl: 'lm-select-multiple-group/lm-select-multiple-group.tpl.html'
      };
    }]);
